import api from "./Api";

// DEVN3-606 — espelho conta contábil → referencial do cliente ("Configurar referencial" em /integracao).
export interface IEspelhoReferencial {
    id: number;
    conta: string;
    nomeConta?: string | null;
    referencial: string;
    dataAtualizacao?: string;
}

export interface IEspelhoReferencialPagina {
    total: number;
    itens: IEspelhoReferencial[];
}

export interface IEspelhoReferencialImportacao {
    inseridas: number;
    atualizadas: number;
    ignoradasSemReferencial: number;
    duplicadasNoArquivo: number;
}

export interface IEspelhoReferencialForm {
    conta: string;
    nomeConta: string;
    referencial: string;
}

class EspelhoReferencialService {
    async listar(q: string, offset: number, limit: number): Promise<IEspelhoReferencialPagina> {
        const { data } = await api.get<IEspelhoReferencialPagina>(`EspelhoReferencial`, { params: { q, offset, limit } });
        return data;
    }

    async criar(form: IEspelhoReferencialForm): Promise<IEspelhoReferencial> {
        const { data } = await api.post<IEspelhoReferencial>(`EspelhoReferencial`, form);
        return data;
    }

    async atualizar(id: number, form: IEspelhoReferencialForm): Promise<IEspelhoReferencial> {
        const { data } = await api.put<IEspelhoReferencial>(`EspelhoReferencial/${id}`, form);
        return data;
    }

    async excluir(id: number): Promise<void> {
        await api.delete(`EspelhoReferencial/${id}`);
    }

    async upload(arquivo: File): Promise<IEspelhoReferencialImportacao> {
        const form = new FormData();
        form.append('file', arquivo, arquivo.name);
        const { data } = await api.post<IEspelhoReferencialImportacao>(`EspelhoReferencial/upload`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data;
    }
}

export default new EspelhoReferencialService();
